import {useEffect} from 'react';
import {isPAYGUser} from '@Utils/user.util';
import type {AiPromptBoxActions} from '@Components/ai-prompt-box/hooks/useAiPromptBox';
import type {AiPromptBox} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {useGetIsAiChatPremiumOnly} from '@Hooks/useGetIsAiChatPremiumOnly';

export const useHandlePromptBoxCreditsPillVisibility = (promptBoxState: AiPromptBox, promptBoxActions: AiPromptBoxActions, fetchedCredits: number | null | undefined): void => {
  const isUserPAYG = isPAYGUser();
  const isSingleLineVariant = promptBoxState.size === AiPromptBoxSize.SINGLE_LINE;
  const isAiChatPremiumOnly = useGetIsAiChatPremiumOnly() ?? false;

  useEffect(() => {
    if (fetchedCredits === undefined || fetchedCredits === null) {
      return;
    }

    const shouldShowPremiumPill = !isSingleLineVariant && isUserPAYG && (isAiChatPremiumOnly || fetchedCredits === 0);
    promptBoxActions.update({
      creditsPill: {
        visible: shouldShowPremiumPill,
        showPremiumIcon: shouldShowPremiumPill,
      },
    });
  }, [fetchedCredits, isUserPAYG, isSingleLineVariant, isAiChatPremiumOnly]);
};
